import React, { useRef, useEffect } from "react";

type Store = {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  [key: string]: any;
};

type StoreFinderMapProps = {
  storesData?: Store[];
  selectedStore?: Store;
  setSelectedStore?: (store: Store) => void;
  query: string;
};

const defaultLocation = { lat: -33.8688, lng: 151.2093 }; // Sydney
let retries = 0;

const StoreFinderMap = ({
  storesData = [],
  selectedStore,
  setSelectedStore,
  query
}: StoreFinderMapProps) => {
  const mapRef = useRef(null);
  const googleMapRef = useRef(null);

  const renderGoogleMap = () => {
    if (!mapRef.current || !window.google || !window.google.maps) return;

    const centerLocation =
      selectedStore && !isNaN(selectedStore.latitude) && !isNaN(selectedStore.longitude)
        ? {
            lat: Number(selectedStore.latitude),
            lng: Number(selectedStore.longitude),
          }

        : query && storesData?.length
            ?  {
                lat: Number(storesData[0].latitude),
                lng: Number(storesData[0].longitude),
              }

            : defaultLocation

    const mapOptions = {
      center: centerLocation,
      zoom: selectedStore ? 14 : 9,
      disableDefaultUI: false,
    };

    googleMapRef.current = new window.google.maps.Map(mapRef.current, mapOptions);

    const storesArray = Array.isArray(storesData) 
      ? storesData.filter((store) => (store.clickandcollect_enabled === 1 || store.sfs_enabled === 1 || store.deptstore_enabled === 1))
      : [];

    storesArray.forEach((store) => {
      if (store?.latitude && store?.longitude) {
        const marker = new window.google.maps.Marker({
          position: {
            lat: store.latitude,
            lng: store.longitude,
          },
          map: googleMapRef.current,
          title: store.name,
          icon: {
            url: "https://cdn.shopify.com/s/files/1/0237/4546/2352/files/marker.svg?v=1742518304",
            scaledSize: new window.google.maps.Size(40, 40),
          },
        });

        // 👉 Handle marker click to trigger setSelectedStore
        marker.addListener("click", () => {
          if (setSelectedStore) {
            setSelectedStore(store);
          }
        });
      }
    });
  };

  const loadGoogleMap = () => {

    const intervalId = setInterval(() => {
      if (window?.google?.maps) {
        clearInterval(intervalId);
        renderGoogleMap();
      } else if (retries > 10) {
        retries = 0;
        clearInterval(intervalId);
      }
      retries++;
    }, 300);
  };

  useEffect(() => {
    loadGoogleMap();
  }, []);

  useEffect(() => {
    loadGoogleMap();
  }, [storesData, selectedStore]);

  return (
    <div
      className="w-full mb-4 -mt-[68px] lg:mt-0 lg:mb-0 max-lg:h-[60vh]"
      ref={mapRef}
    ></div> 
  );
};

export default StoreFinderMap;